module.exports = __webpack_public_path__ + "static/media/logo_inv.943d5841.png";